import React, { useCallback, useEffect, useState } from 'react';
import { Button, Collapse, Form } from 'react-bootstrap';
import { getUserActivityAPI } from '../../../Services/mockApi';
import PageHeader from '../../../Components/shared/PageHeader';
import LoadingSkeleton from '../../../Components/shared/LoadingSkeleton';
import { companyUrl } from '../../../utils/mhNav';
import styles from './UserActivity.module.scss';

export default function UserActivity() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState({});
  const [range, setRange] = useState({ from: '', to: '' });

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await getUserActivityAPI(range);
      setRows(res.data?.rows || []);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, [range]);

  useEffect(() => {
    load();
  }, [load]);

  if (error && !rows.length) {
    return (
      <div>
        <PageHeader title="User activity" breadcrumbs={[{ label: 'Company', path: companyUrl('dashboard') }, { label: 'Audit', path: companyUrl('audit') }, { label: 'User activity' }]} />
        <Button onClick={load}>Retry</Button>
      </div>
    );
  }

  return (
    <div>
      <PageHeader
        title="User activity"
        breadcrumbs={[
          { label: 'Company', path: companyUrl('dashboard') },
          { label: 'Audit', path: companyUrl('audit') },
          { label: 'User activity' },
        ]}
      />
      <div className="d-flex gap-2 mb-3">
        <Form.Control type="date" size="sm" style={{ width: 160 }} value={range.from} onChange={(e) => setRange((r) => ({ ...r, from: e.target.value }))} />
        <Form.Control type="date" size="sm" style={{ width: 160 }} value={range.to} onChange={(e) => setRange((r) => ({ ...r, to: e.target.value }))} />
      </div>
      {loading && !rows.length ? (
        <LoadingSkeleton rows={5} cols={4} />
      ) : (
        <div>
          {(rows || []).map((r) => {
            const inactive = r.meetingsCreated === 0 && r.updates === 0 && r.momApprovals === 0;
            return (
              <div key={r.userId} className={`mb-2 border rounded ${inactive ? styles.inactive : ''}`}>
                <button
                  type="button"
                  className={`${styles.rowBtn} w-100 text-start p-2 bg-transparent border-0`}
                  onClick={() => setOpen((o) => ({ ...o, [r.userId]: !o[r.userId] }))}
                >
                  <strong>{r.displayName}</strong>
                  <span className="text-muted small ms-2">
                    created {r.meetingsCreated} · updates {r.updates} · MOM {r.momApprovals} · last{' '}
                    {new Date(r.lastActionAt).toLocaleString()}
                  </span>
                </button>
                <Collapse in={open[r.userId]}>
                  <div className="px-3 pb-2 small">
                    <ul>
                      {(r.events || []).map((e, i) => (
                        <li key={i}>{new Date(e.at).toLocaleString()} — {e.type}: {e.detail}</li>
                      ))}
                    </ul>
                  </div>
                </Collapse>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
